import { yupResolver } from "@hookform/resolvers/yup"
import { Typography } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import React from "react"
import { useForm, Controller } from "react-hook-form"
import { withRouter } from "react-router"

import ChooseItem from "areas/order/choose-item"
import ContactInformation from "areas/order/contact-information"
import processOrder from "areas/order/helper/process-order"
import Reason from "areas/order/reason"

import {
  CancelButton,
  FormContainer,
  InputWrapper,
  OrderNumber,
  SubmitButton,
} from "../components"
import Heading from "../heading"

import Dropzone from "./dropzone"
import validationSchema from "./validate"

const OrderForm = ({ history, orderData }) => {
  const numEligibleItems = orderData.order.number_of_eligible_items
  const defaultItem =
    numEligibleItems === 1
      ? orderData.order.line_items.find(
          (item) => !item.error_message && !item.has_in_progress_rma
        )
      : null

  const {
    control,
    formState: { errors, isDirty, isSubmitting, isValid },
    handleSubmit,
    setError,
    setValue,
    watch,
  } = useForm({
    defaultValues: {
      contact_email: "",
      contact_name: "",
      contact_phone_num: "",
      files: [],
      notes: "",
      repairItems: defaultItem ? [defaultItem.id] : [],
      rma_reason: "",
    },
    mode: "onBlur",
    resolver: yupResolver(validationSchema(orderData)),
  })

  const onSubmit = async (values) => {
    try {
      const formValues = {
        ...values,
        files: JSON.stringify(values.files),
        order_number: orderData.order.number,
        repairItems: values.repairItems,
      }

      await processOrder(formValues, "process_repair")
      history.push("/order/completed_repair")
    } catch (err) {
      console.log(err)
      setError("root.error", {
        message: err?.errors?.[0] || err?.message || err,
      })
    }
  }

  return (
    <FormContainer>
      <Heading rmaType="repair" />
      <Typography fontSize="18px" fontWeight="500" lineHeight="20px">
        Your Order Number:
      </Typography>
      <OrderNumber>{orderData.order.number}</OrderNumber>
      <form onSubmit={handleSubmit(onSubmit)}>
        <ChooseItem
          control={control}
          errors={errors}
          formType="repair"
          items={watch("repairItems")}
          lineItems={orderData.order.line_items}
          numEligibleItems={numEligibleItems}
        />
        <ContactInformation control={control} />
        <Reason
          control={control}
          formType="repair"
          items={watch("repairItems")}
          line_items={orderData?.order?.line_items}
        />
        <Controller
          control={control}
          name="files"
          render={({ fieldState: { error } }) => (
            <Dropzone error={error} setValue={setValue} />
          )}
        />
        <InputWrapper>
          <SubmitButton disabled={!(isValid && isDirty)} loading={isSubmitting}>
            Process Request
          </SubmitButton>

          <CancelButton data-lc="order-form" to="/">
            Cancel and Continue Shopping
          </CancelButton>
        </InputWrapper>
        {errors?.root?.error && (
          <Typography color="error" mb={1}>
            {errors.root.error.message}
          </Typography>
        )}
      </form>
    </FormContainer>
  )
}

OrderForm.propTypes = {
  history: PropTypes.object,
  orderData: PropTypes.object,
}

export default withRouter(OrderForm)
